/*jshint esversion: 6 */

// © 2021 by Voxny404
//  _   __                    ____ ___  ____
// | | / /__ __ __ ___  __ __/ / // _ \/ / /
// | |/ / _ \\ \ // _ \/ // /_  _/ // /_  _/
// |___/\___/_\_\/_//_/\_, / /_/ \___/ /_/
//                    /___/
// https://voxny404.github.io/portfolio

class ErrorHandler {
    constructor(t) {
        this.t = t;
    }

    setTranslationFunction(t) {
        this.t = t;
    }

    getErrorResponse(errorMessage) {
        if (!this.t) return; // console.warn("Attempted to access ErrorHandler before initialization. Please initialize ErrorHandler first.");

        return this.t(errorMessage); // Translate the error message
    }

    handleErrorCode(object) {
        let response = null;

        if (!object.status) response = this.getErrorResponse("NO_STATUS_CODE");
        if (!object.body) response = this.getErrorResponse("NO_BODY_CODE");

        try {
            if (object.body) {
                let responseBodyObject = JSON.parse(object.body);
                response = this.getErrorResponse(responseBodyObject.errorCode);
            } else {
                response = this.getErrorResponse(object.errorCode);
            }
        } catch (error) {
            console.error(error);
            response = this.getErrorResponse("CATCH_ERROR");
        }
        return response;
    }

    bootOutMessage(message) {
        return (window.location.href = "/?params=" + message);
    }

    displayMessage(message) {
        return this.getErrorResponse(message);
    }

    handleStatusError(status) {
        if (status === 200) return;

        let statusMap = {
            401: "UNAUTHORIZED",
            403: "SESSION_EXPIRED",
            408: "REQUEST_TIMEOUT",
            504: "SERVER_NOT_REACHABLE",
        };

        if (statusMap[status]) this.bootOutMessage(statusMap[status]);
        if (status >= 500) this.bootOutMessage("DEFAULT_ERROR");
        return;
    }

    handleFetch(object) {
        try {
            this.handleStatusError(object.status);
            return object.json();
        } catch (error) {
            console.error("FETCH ERROR: " + object.status);
            this.handleStatusError(object.status);
            return object;
        }
    }

    handleFetchWithoutParsing(object) {
        this.handleStatusError(object.status);
        return object;
    }
}
const singleton = new ErrorHandler();
export default singleton;
